
import { Component, OnInit,Input} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { UserManagementService } from '../../../Services/user-management/user-management.service';
import { PowerUserFormData } from '../../../Models/user-profiles.model';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from '../../../Services/session.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-power-user-registration',
  templateUrl: './power-user-registration.component.html',
  styleUrls: ['./power-user-registration.component.scss'],
  providers: [DatePipe]
})
export class PowerUserRegistrationComponent implements OnInit {
 // @Input('Close') Close:Subject<any>;
  Assignroletouser:boolean=false;
  isAmailAddress: Boolean = false;
  educationalQualifications: any[];
  experienceType: any[];
  LanguageType:any[];
  countryName: any[];
  countryCode: any[];
  State: any[];
  powerUserStatus: any;
  DataUpdateFlag:boolean=false;
  powerUserRegistration: PowerUserFormData;
  CopyText:string='New'
  powerUserRegistrationForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    middleName: new FormControl(''),
    lastName: new FormControl('', Validators.required),
    countryCode1: new FormControl('', Validators.required),
    countryCode2: new FormControl(''),
    fullName: new FormControl({ value: "", disabled: true }),
    emailAddress: new FormControl('', Validators.compose([
      Validators.required,
      Validators.email
    ])),
    primaryPhoneNumber: new FormControl(null, Validators.compose([
      Validators.required,
      Validators.pattern("^[0-9]{10}$"),
    ])),
    secondaryPhoneNumber: new FormControl(''),
    addressLine1: new FormControl('', Validators.required),
    addressLine2: new FormControl(''),
    PostOffice: new FormControl(''),
    State: new FormControl('', Validators.required),
    City: new FormControl('', Validators.required),
    PINcode: new FormControl(null, Validators.required),
    Country: new FormControl('', Validators.required),
    educationQualification: new FormControl('', Validators.required),
    Experience: new FormControl('', Validators.required),
    Comment_Text:new FormControl(''),
    status: new FormControl(''),
    PrimaryLanguage:new FormControl('',Validators.required),

  })

  constructor(
    private sessionService: SessionService,
    public toastr: ToastrService,
    private router: Router,
    public userService: UserManagementService,
    private datePipe: DatePipe
  ) {

    // this.Close.subscribe(e => {
    //  this.Closepopup();
    // });
  }

  ngOnInit(): void {
    this.getEducationalQualification();
    this.getExperienceType();
    this.getCountryName();
    this.getCountryCode();
    this.getUserState();
    this.getLanguage();
  }


  isSaveDisabled(): boolean {
    return (
      this.powerUserRegistrationForm.invalid ||
      this.phonenumber1flag ||
      this.phonenumber2flag ||
      this.countrynumber1flag ||
      this.countrynumber2flag
    );
  }
  onCountryChange(event: any){
    const country = event.target.value;
    this.powerUserRegistrationForm.controls['State'].setValue(null)
    this.getUserState(country)
    this.Editformvalidation()

  }

  getPowerUserStatus() {
    this.userService.getCodes('POWER_USER_STATUS_TYPE').subscribe(
      res => {
        console.log(res)
      },
      error => {
        console.log(error)
      }
    )
  }

  getUserState(country?:string) {
    this.userService.getStates(country).subscribe(
      res => {
        this.getUserStatesResponse(res)
      },
      error => {
        console.log(error)
      }
    )
  }



  getUserStatesResponse(data: any) {
    var tempUserStates: any[] = []

    data.forEach((element: { Code: any; Name: any; }) => {
      tempUserStates.push({
        Code: element.Code,
        Name: element.Name
      })

    });

    this.State = tempUserStates;
  }

  getExperienceType() {
    this.userService.getCodes('EXPERIENCE_TYPE').subscribe(
      res => {
        this.getExperienceTypeResponse(res)

      },
      error => {
        console.log(error)
      }

    )
  }

  getLanguage() {
    this.userService.getCodes('Language_Type').subscribe(
      res => {
        this.getLanguageTypeResponse(res)

      },
      error => {
        console.log(error)
      }

    )
  }

  getLanguageTypeResponse(data:any){
    var tempLanguageType: any[] = []

    data.forEach((element: { Code: any; Name: any; }) => {
      tempLanguageType.push({
        Code: element.Code,
        Name: element.Name
      })

    });



    this.LanguageType = tempLanguageType;
  }

  getExperienceTypeResponse(data:any) {
    var tempExperienceType: any[] = []

    data.forEach((element: { Code: any; Name: any; }) => {
      tempExperienceType.push({
        Code: element.Code,
        Name: element.Name
      })

    });



    this.experienceType = tempExperienceType;
  }


  getEmailErrorMessage() {
    this.isAmailAddress = true;
  }



  getEducationalQualification() {
    this.userService.getCodes('EDUCATION_TYPE').subscribe(
      res => {
        this.getEducationalQualificationResponse(res)
      },
      error => {
        console.log(error)
      }
    )
  }

  getEducationalQualificationResponse(data: any) {
    var tempEducationalQualifications: any[] = []

    data.forEach((element: { Name: any; Code: any; }) => {

      tempEducationalQualifications.push({
        Name: element.Name,
        Code: element.Code
      })
    })


    this.educationalQualifications = tempEducationalQualifications;
  }

  getCountryName() {
    this.userService.getCodes('COUNTRY').subscribe(
      res => {
        this.getCountryNameResponse(res)
      },
      error => {
        console.log(error)
      }
    )
  }

  getCountryNameResponse(data:any) {
    var tempCountryName: any[] = []

    data.forEach((element: { Code: any; Name: any; }) => {
      tempCountryName.push({
        Code: element.Code,
        Name: element.Name
      })
    })

    this.countryName = tempCountryName;

  }

  getCountryCode() {
    this.userService.getCodes('PHONE_COUNTRY_CODE').subscribe(
      res => {
        this.getCountryCodeResponse(res)
      },
      error => {
        console.log(error)
      }
    )
  }

  getCountryCodeResponse(data:any) {
    var tempCountryCode: any[] = []

    data.forEach((element: { Code: any; Name: any; }) => {
      tempCountryCode.push({
        Code: element.Code,
        Name: element.Name
      })
    })
    this.countryCode = tempCountryCode;
  }



  Closepopup(data:any){
    if(this.Assignroletouser){
      this.onClickAssignRoleButton();
    }

  }

  onClickAssignRoleButton() {
    this.Assignroletouser=!this.Assignroletouser;

  }

  saveOnClick() {
    this.powerUserRegistrationForm.controls['fullName'].setValue(this.powerUserRegistrationForm.controls['firstName'].value + " " + this.powerUserRegistrationForm.controls['lastName'].value)
    this.userService.checkDuplicateEmail({ Name: this.powerUserRegistrationForm.controls['emailAddress'].value,ID:null,ScreenName:'POWER_USER' }).subscribe(
      res => {
        if(res.status){
        this.PostOnClickSubmitForm(this.powerUserRegistrationForm.value)
        }else{
          this.toastr.error('A power user with the same email exists!','ERROR!' ,{timeOut:3000});
        }
      },
      error => {
        console.log(error)
      }
    );
  }

  PostOnClickSubmitForm(data: any) {
    var tempRegistration: PowerUserFormData;

    tempRegistration = ({
      PowerUserId: '',
      LastName: data.lastName,
      MiddleName: data.middleName,
      FirstName: data.firstName,
      Email: data.emailAddress,
      PrimaryPhoneCountryCode: data.countryCode1,
      PrimaryPhoneNumber: data.primaryPhoneNumber,
      SecondaryPhoneCountryCode: data.countryCode2,
      SecondaryPhoneNumber: data.secondaryPhoneNumber,
      PrimaryLanguage:data.PrimaryLanguage,
      EducationType: data.educationQualification,
      ExperienceType: data.Experience,
      UserStatusType: "New",
      LoggedInUser: this.sessionService.getUser(),
      Address:
      {
        AddressId: 0,
        AddressLine1: data.addressLine1,
        AddressLine2: data.addressLine2,
        AddressLine3: data.PostOffice,
        CityName: data.City,
        StateCode: data.State,
        CountryCode: data.Country,
        PostalCode: data.PINcode,
      },
      CreatedBy:this.sessionService.getUser(),
      CreationDate: this.datePipe.transform(new Date(), 'M/d/yyyy h:mm:ss a') || '',
      ExperienceDescription:data.Comment_Text,
    })

    this.powerUserRegistration = tempRegistration
    this.userService.addPowerUser(this.powerUserRegistration).subscribe(
      res => {
        this.toastr.success('Success!', 'Power User Created!');
        this.router.navigate(['User/Poweruserlist']);
      },
      error => {
        //this.toastr.error('ERROR!', 'A power user with the same email exists!');
        console.log(error)
        // this.toastr.error(error.error.Message);
      }
    )

  }



  Cancelbutton(){
    this.Editformvalidation();
    if(this.DataUpdateFlag){
      this.AlertCancelpopup();
    }
    else{
     this.DiscardChanges();
    }

     //this.router.navigate(['User/Poweruserlist']);


   }
   cancelalertflag:boolean
   AlertCancelpopup(){
    this.cancelalertflag=!this.cancelalertflag;
   }

   DiscardChanges(){
     this.AlertCancelpopup();
      this.router.navigate(['User/Poweruserlist']);
   }

   Editformvalidation()
   {



     //if(this.powerUserRegistrationForm.valid){
     var firstName = this.powerUserRegistrationForm.controls['firstName'].value;
     var middleName = this.powerUserRegistrationForm.controls['middleName'].value;
     var lastName = this.powerUserRegistrationForm.controls['lastName'].value;
     var countryCode1 = this.powerUserRegistrationForm.controls['countryCode1'].value;
     var countryCode2 = this.powerUserRegistrationForm.controls['countryCode2'].value;
     var fullName = this.powerUserRegistrationForm.controls['fullName'].value;
     var status = this.powerUserRegistrationForm.controls['status'].value;
     var emailAddress = this.powerUserRegistrationForm.controls['emailAddress'].value;
     var primaryPhoneNumber = this.powerUserRegistrationForm.controls['primaryPhoneNumber'].value;
     var secondaryPhoneNumber = this.powerUserRegistrationForm.controls['secondaryPhoneNumber'].value;
     var addressLine1 = this.powerUserRegistrationForm.controls['addressLine1'].value;
     var addressLine2 = this.powerUserRegistrationForm.controls['addressLine2'].value;
     var PostOffice = this.powerUserRegistrationForm.controls['PostOffice'].value;
     var State = this.powerUserRegistrationForm.controls['State'].value;
     var City = this.powerUserRegistrationForm.controls['City'].value;
     var PINcode = this.powerUserRegistrationForm.controls['PINcode'].value;
     var Country = this.powerUserRegistrationForm.controls['Country'].value;
     var educationQualification = this.powerUserRegistrationForm.controls['educationQualification'].value;
     var Experience = this.powerUserRegistrationForm.controls['Experience'].value;
     var Comment_Text = this.powerUserRegistrationForm.controls['Comment_Text'].value;
     var primarylanguage = this.powerUserRegistrationForm.controls['PrimaryLanguage'].value;
     // if(Comment_Text==""){
     //   Comment_Text=null;
     // }

     if(firstName!=null&&firstName!=''&&firstName!='undefined')
     this.DataUpdateFlag=true;
     else if(primarylanguage!=null&&primarylanguage!=''&&primarylanguage!='undefined')
     this.DataUpdateFlag=true;
     else if(middleName!=null&&middleName!=''&&middleName!='undefined')
     this.DataUpdateFlag=true;
     else if(PostOffice!=null&&PostOffice!=''&&PostOffice!='undefined')
     this.DataUpdateFlag=true;
     else if(lastName!=null&&lastName!=''&&lastName!='undefined')
     this.DataUpdateFlag=true;
     else if(countryCode1!=null&&countryCode1!=''&&countryCode1!='undefined')
     this.DataUpdateFlag=true;
     else if(countryCode2!=null&&countryCode2!=''&&countryCode2!='undefined')
     this.DataUpdateFlag=true;
     else if(status!=null&&status!=''&&status!='undefined')
     this.DataUpdateFlag=true;
     else if(emailAddress!=null&&emailAddress!=''&&emailAddress!='undefined')
     this.DataUpdateFlag=true;
     else if(primaryPhoneNumber!=null&&primaryPhoneNumber!=''&&primaryPhoneNumber!='undefined')
     this.DataUpdateFlag=true;
     else if(secondaryPhoneNumber!=null&&secondaryPhoneNumber!=''&&secondaryPhoneNumber!='undefined')
     this.DataUpdateFlag=true;
     else if(addressLine1!=null&&addressLine1!=''&&addressLine1!='undefined')
     this.DataUpdateFlag=true;
     else if(addressLine2!=null&&addressLine2!=''&&addressLine2!='undefined')
     this.DataUpdateFlag=true;
     // else if(PostOffice!=this.getpoweruser[0].Answer_Selection_Type_Code)
     // this.DataUpdateFlag=true;
     else if(State!=null&&State!=''&&State!='undefined')
     this.DataUpdateFlag=true;
     else if(City!=null&&City!=''&&City!='undefined')
     this.DataUpdateFlag=true;
     else if(PINcode!=null&&PINcode!=''&&PINcode!='undefined')
     this.DataUpdateFlag=true;
     else if(Country!=null&&Country!=''&&Country!='undefined')
     this.DataUpdateFlag=true;
     else if(educationQualification!=null&&educationQualification!=''&&educationQualification!='undefined')
     this.DataUpdateFlag=true;
     else if(Experience!=null&&Experience!=''&&Experience!='undefined')
     this.DataUpdateFlag=true;
     else if(Comment_Text!=null&&Comment_Text!=''&&Comment_Text!='undefined')
     this.DataUpdateFlag=true;
     else
     this.DataUpdateFlag=false;

    //}


 }

  phonenumber1flag:boolean=false;
  phonenumber2flag:boolean=false;
  countrynumber1flag:boolean=false;
  countrynumber2flag:boolean=false;
  selectcountrycode(){
    if(!this.powerUserRegistrationForm.controls['primaryPhoneNumber'].value){
      if(this.powerUserRegistrationForm.controls['countryCode1'].value==" "){
        this.phonenumber1flag=false;
      }
      else{
        this.phonenumber1flag=true;
      }
      //this.phonenumber1flag=true;
    }

    if(this.powerUserRegistrationForm.controls['countryCode1'].value){
      this.countrynumber1flag=false;
    }
    else{
      this.countrynumber1flag=true;
    }
  }
  selectcountrycode1(){
    if(!this.powerUserRegistrationForm.controls['secondaryPhoneNumber'].value){
      if(this.powerUserRegistrationForm.controls['countryCode2'].value==" "){
        this.phonenumber2flag=false;
      }
      else{
        this.phonenumber2flag=true;
      }

    }

    if(this.powerUserRegistrationForm.controls['countryCode2'].value){
      this.countrynumber2flag=false;
    }
    else{
      this.countrynumber2flag=true;
    }
  }
  selectphonemnumber1(){
    if(!this.powerUserRegistrationForm.controls['countryCode1'].value){
      this.countrynumber1flag=true;
    }
    if(this.powerUserRegistrationForm.controls['primaryPhoneNumber'].value){
      this.phonenumber1flag=false;
    }
    else{
      this.phonenumber1flag=true;
    }
  }
  selectphonemnumber2(){
    if(!this.powerUserRegistrationForm.controls['countryCode2'].value){
      this.countrynumber2flag=true;
    }
    if(this.powerUserRegistrationForm.controls['secondaryPhoneNumber'].value){
      this.phonenumber2flag=false;
    }
    else{
      if(this.powerUserRegistrationForm.controls['countryCode2'].value==" "){
        this.phonenumber2flag=false;
      }
      else{
        this.phonenumber2flag=true;
      }
      //this.phonenumber2flag=true;
    }
  }


}
